import { useState } from 'react';

import { isMobile } from '@zola-helpers/client/dist/es/util/responsive';
import { PhotoIcon } from '@zola/zola-ui/src/components/SvgIconsV3/Photo';
import COLORS from '@zola/zola-ui/src/styles/emotion/colors3';

import MobileLightbox from '~/components/common/ui/CoverGalleryV2/MobileLightbox';
import NotMobileLightbox from '~/components/common/ui/CoverGalleryV2/NotMobileLightbox';
import { MappedReviewView } from '~/types/responseTypes';

import {
  PhotoCount,
  PhotoIconAndCount,
  PhotoPreview,
  PhotoPreviewOverlay,
  ReviewsSectionGalleryWrapper,
  StyledCachedImage,
} from './ReviewsSectionGallery.styles';

type ReviewsSectionGalleryProps = {
  review: MappedReviewView;
};

export const ReviewsSectionGallery = ({ review }: ReviewsSectionGalleryProps): JSX.Element => {
  const [selectedUuid, setSelectedUuid] = useState<string | undefined>();

  const onClickImage = (uuid: string) => {
    setSelectedUuid(uuid);
  };

  const onCloseLightbox = () => {
    setSelectedUuid(undefined);
  };

  return review.reviewPhotos.length > 0 ? (
    <ReviewsSectionGalleryWrapper>
      {review.reviewPhotos.map((photo, i) => {
        const morePhotosCount = review.reviewPhotos.length - (isMobile() ? 3 : 4);
        const showMorePhotosCountDesktop = !isMobile() && morePhotosCount > 0 && i === 3;
        const showMorePhotosCountMobile = isMobile() && morePhotosCount > 0 && i === 2;

        return (
          <PhotoPreview
            hideOnDesktop={i > 3}
            hideOnMobile={i > 2}
            key={`reviews-section-gallery-${i}`}
            onClick={() => onClickImage(photo.uuid)}
          >
            <StyledCachedImage uuid={photo.uuid} />
            {showMorePhotosCountDesktop || showMorePhotosCountMobile ? (
              <>
                <PhotoPreviewOverlay />
                <PhotoIconAndCount>
                  <PhotoIcon color={COLORS.WHITE_100} height={24} title="" width={24} />
                  <PhotoCount>({morePhotosCount}+)</PhotoCount>
                </PhotoIconAndCount>
              </>
            ) : null}
          </PhotoPreview>
        );
      })}
      {selectedUuid && (
        <>
          {isMobile() ? (
            <MobileLightbox initialUuid={selectedUuid} onClose={onCloseLightbox} showReviewPhotos />
          ) : (
            <NotMobileLightbox
              initialUuid={selectedUuid}
              onClose={onCloseLightbox}
              showReviewPhotos
            />
          )}
        </>
      )}
    </ReviewsSectionGalleryWrapper>
  ) : (
    <></>
  );
};
